import { render } from "./vChart.vue?vue&type=template&id=1528a5f0&scoped=true"
import script from "./vChart.vue?vue&type=script&lang=js"
export * from "./vChart.vue?vue&type=script&lang=js"

import "./vChart.vue?vue&type=style&index=0&id=1528a5f0&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1528a5f0"]])

export default __exports__